// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	document.addEventListener('DOMContentLoaded', () => {
		/* Lightbox Copy */
		const customLightbox = new LBX('.js-lbx-copy', {
            customClass: 'lbx-copy',
        });
		const customLightboxMenus = new LBX('.js-lbx-menus', {
            customClass: 'lbx-menus',
        });

		scrollW();
	})

	/* Submenu on mobile */
	function submenu(){
		var submenuHold = document.querySelectorAll('.sub-menu__hold');
		var allsublinks = document.querySelectorAll('.sub-menu a');
		if(allsublinks.length > 1){
			allsublinks.forEach(ele=>{
				ele.addEventListener('click', function(ev){
					if(ele.classList.contains('active')){
						ev.preventDefault();
					}
				});
			});
			var toggleBtn = document.querySelector('.sub-menu__toggle');
			if(toggleBtn){
				toggleBtn.textContent = document.querySelector('.sub-menu a.active').textContent;
				toggleBtn.addEventListener('click', function(){
					toggleBtn.parentElement.classList.toggle('open');
				});
			}
		}else if(submenuHold.length > 0){
			submenuHold[0].classList.add('d-none');
		}
		
	}
	submenu();


	let dropdownImages = document.getElementById('dropdwonImages');
	let primaryNavDrop = document.querySelectorAll('#primary-nav .submenu li');
	if(dropdownImages){
		primaryNavDrop.forEach((li , i) => { 	
			let j = i - 1;
		
			let dropA = li.querySelector('a');
			if(dropA.innerHTML != 'Overview'){
				
				let dataImage = dropdownImages.querySelectorAll('span');
				let eachData = "";
				if (dataImage && dataImage[i]) {
					eachData = dataImage[i].getAttribute('data-image');
				}
				
				let imageDrop = document.createElement('img');
				imageDrop.setAttribute("class", 'dropdown-image');			
				imageDrop.setAttribute("src", eachData);
				dropA.appendChild(imageDrop);
			}else{
				dropA.parentElement.classList.add('n_img');
				dropA.parentElement.parentElement.classList.add('extraSpace');
			}	
		})
	}
	

	// label move on focus forms
	let allForms = document.querySelectorAll('form.form-module');
	allForms.forEach(form => { 
		let fields = form.querySelectorAll('.form-module__field');
		fields.forEach(field => { 
			let label = field.querySelector('label:not(.error)');
			field.addEventListener('focusin', () => { 
				label.classList.add('focus');
				// if(!label.nextElementSibling.classList.contains('error')){
				// 	label.classList.add('focus');
				// }
				// field.addEventListener('keyup', () => { 
				// 	if(!label.nextElementSibling.classList.contains('error')){
				// 		label.classList.add('focus');
				// 	}
				// });
			});
		})
	})

	

	// Main Nav Dropdown
	let primaryNav = document.getElementById('primary-nav');
	if(primaryNav){
		primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
			primary_nav.addEventListener("mouseover", (event) => {
				primary_nav.classList.add('hover');
				if(primary_nav.querySelector('ul.submenu')){
					primary_nav.querySelector('ul.submenu').classList.add('open');
				}
			});
			primary_nav.addEventListener("mouseout", (event) => {
				primary_nav.classList.remove('hover');
				if(primary_nav.querySelector('ul.submenu')){
					primary_nav.querySelector('ul.submenu').classList.remove('open');
				}
			});
		});
	}

		// SHOW SUBMENU FUNCTION: 

		const submenuToShow = (linksSelector, linkSubmenu) => {
			let navLinks = document.querySelectorAll(linksSelector); 
			let submenu_active = document.querySelectorAll(linkSubmenu); 
	
			navLinks.forEach(link => {
				const parent = link.parentNode;
				let submenu = parent.querySelector('.submenu');
				link.addEventListener('click', (e) => {
					link.classList.toggle('active');
					submenu.classList.toggle('active');
				});
			});
			submenu_active.forEach(sub => {
				if (sub.classList.contains('active')) {
					if (window.screen.width > 640) {
						let selectedLink = sub.parentNode.parentNode.parentNode.children[0];
						selectedLink.classList.add('selected');
					}else{
						let selectedLink = sub.parentNode.parentNode.parentNode.parentNode.children[0];
						selectedLink.classList.add('selected');
					}
				}
	
			})
		}
	
		if (window.screen.width < 640) {
			submenuToShow('.mobileMenu__nav li a', '.sub-sub-menu .submenu li a');
		}
	

	
	
	// Preloader  Content
	var svgContainer = document.getElementById('preloader-js');
	let gifsrc = 'assets/images/logo-animate.gif';
	if(svgContainer){
		setTimeout(function(){
			svgContainer.classList.add('close');
		}, 3300);
		setTimeout(function(){
			svgContainer.querySelector('.logo-animated').setAttribute('style', `background-image: url(${gifsrc})`);
		}, 500);
	}
	
	//booking funcionality
	const ctabooking = document.querySelector(".booking-cta");
	const bookingcontain = document.querySelector(".booking-block");
	const closebooking = document.querySelector(".bookingclose-cta");

	//Open booking
	if(ctabooking){
		ctabooking.addEventListener("click", function (e) {
			e.preventDefault();
			bookingcontain.classList.add("open");
		});
	}

	//Close booking
	if(closebooking){
		closebooking.addEventListener("click", function (e) {
			e.preventDefault();
			bookingcontain.classList.remove("open");
		});
	}

	

	// Menus Live Text
	if(document.getElementsByClassName("menu-quad")[0]){
		let menuCategories = document.querySelectorAll(".menu-quad .menu-quad__tabs .js-menu-tab");
		let menusSelector = document.getElementById("menusSelector");
		console.log(menusSelector);
		
		let ulMenu = document.querySelector(".menu-quad ul");
		for(let c = 0; c < menuCategories.length; c++){
			menuCategories[c].addEventListener('click', function (e) {
				e.preventDefault();		
				let menuImages = document.querySelectorAll(".menu-tab-figure");
				
				for(let x = 0; x < menuImages.length; x++){
					menuImages[x].classList.remove("active");
					menuImages[c].classList.add("active");
				}

				let currentCat = this.getAttribute("data-tag");
				document.querySelectorAll(".menu-quad [data-tag]").forEach(item => { item.classList.remove('active'); })
				document.querySelectorAll(`.menu-quad [data-tag="${currentCat}"] `).forEach(item => { item.classList.add('active'); })

				if(menusSelector){
					menusSelector.value = currentCat;
				}
				ulMenu.classList.remove("open");

			});
			menuCategories[0].click();
		};
		if(menusSelector){
			menusSelector.addEventListener('click', function () {	
				ulMenu.classList.toggle("open");
			})
		}        
	}



	// PARALLAX ANIMATION *****************************************************/

	const scrollParallax = {};

	const v_height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

	function doParallax(elm) {
	let bounds = elm.dataset.parallax.split(",").map(Number);
	let distance = bounds[1] - bounds[0];
	let unit_scroll = distance / (v_height + elm.offsetHeight);

	let topElement = elm.getBoundingClientRect().top + window.pageYOffset;

	let beforeSpeed = parseFloat(elm.dataset.parallaxSpeedBefore) || 1.0;
	let afterSpeed = parseFloat(elm.dataset.parallaxSpeedAfter) || 1.0;

	let parallaxFunction = function () {
		let scrolled = window.pageYOffset;
		let relative_distance = scrolled + v_height - topElement;
		let temp = unit_scroll * relative_distance + bounds[0];

		elm.style.transform = `translate(0, ${temp}px)`;
	};

	scrollParallax[elm.dataset.parallaxid] = parallaxFunction;

	window.addEventListener('scroll', scrollParallax[elm.dataset.parallaxid]);
	}

	let observers_parallax_elements = document.querySelectorAll(".js-parallax-element");
	observers_parallax_elements.forEach((elm) => {
	doParallax(elm);
	});

	const options_parallax = {
	root: null,
	rootMargin: '0px',
	threshold: 0,
	};

	function handler_parallax(entries) {
		entries.forEach((entry) => {
			const target = entry.target;
			const id_elem = target.dataset.parallaxid;

			if (entry.isIntersecting) {
			doParallax(target);
			} else {
			window.removeEventListener('scroll', scrollParallax[id_elem]);
			}
		});
	}

	const observable_parallax = new IntersectionObserver(handler_parallax, options_parallax);
	let counter = 1;

	observers_parallax_elements.forEach((element) => {
	observable_parallax.observe(element);
	element.dataset.parallaxid = counter;
	counter++;
	});


	// Menu Functionality

		let menuContent = document.getElementById("navigationBox");
		let header = document.getElementById("header");
		let menuBtn = document.querySelector("[data-show_nav]");
		let closeMenuBtn = document.querySelector("[data-close_nav]");
		// let menuLabel = menuBtn.querySelector('span.label');
		//Open/CLose

		if(menuBtn){
			menuBtn.addEventListener('click', function (e) {
				menuBtn.classList.toggle("open");
				menuContent.classList.toggle("open");
				header.classList.toggle("menuOpen");
			});
		}

		if(closeMenuBtn){
			closeMenuBtn.addEventListener('click', function (e) {
				menuBtn.classList.remove("open");
				menuContent.classList.remove("open");
				header.classList.remove("menuOpen");
			});
		}

		// Main Site Language
		document.querySelectorAll(".js-language-span").forEach(languageSpan => {
			languageSpan.addEventListener("click", function(e){
				console.log(languageSpan.getAttribute("value"));
				changeLanguage(languageSpan.getAttribute("value"));
			});
		});

		let langArrowSelect = document.getElementById("langArrowSelect");
		let languageList = document.getElementById("language");
		if(langArrowSelect){
			langArrowSelect.addEventListener("click", function(e){
				langArrowSelect.classList.toggle("open");
				languageList.classList.toggle("open");
			});
		}

	window.addEventListener('scroll', function(){
		scrollW();
	})

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
		if(st > 80){
			if(!document.getElementById('header').classList.contains('scroll')){
				document.getElementById('header').classList.add('scroll');
			}
		} else {
			if(document.getElementById('header').classList.contains('scroll')){
				document.getElementById('header').classList.remove('scroll');
			}
		}
		lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling	
}